module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/pdp_paperTripleThick-ebb6c0b7e708ecc0d6b1d254ad189475.jpg";